import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Send the admin session cookie on every API call. The cookie is HttpOnly
// (XSS-safe) and SameSite=Strict (CSRF-safe). Required for cookie-based
// admin auth — see /app/standalone_casino/frontend/src/lib/adminApi.js.
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
